import { Info } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

/**
 * Le bandeau des écrans de démonstration du centre d'aide (#105) : des données
 * fictives, rien d'enregistré — et le chemin du retour.
 */
function DemoBanner({ backTo }: { backTo: string }) {
  const { t } = useTranslation()

  return (
    <div role="note" className="mb-4 flex flex-wrap items-center justify-between gap-2 rounded-lg border border-dashed border-border bg-muted/40 px-4 py-2 text-sm">
      <span className="flex items-center gap-2">
        <Info className="size-4 shrink-0 text-muted-foreground" />
        {t('helpDemo.banner')}
      </span>
      <Link to={backTo} className="font-medium underline underline-offset-4">{t('helpDemo.back')}</Link>
    </div>
  )
}

export default DemoBanner
